import postRequest from 'utils/postRequest'
import getRequest from 'utils/getRequest'
import deleteRequest from 'utils/deleteRequest'
import putRequest from 'utils/putRequest'
import patchRequest from 'utils/patchRequest'
import filterNullAndUndefinedFieldsFromObject from 'utils/filterNullAndUndefinedFieldsFromObject'

const path = '/api/site-habitat'
const reassessmentPath = '/api/reassessment/sites'

//eslint-disable-next-line
export const requestCreateSiteHabitat = (siteId, siteHistoryId, { Level1HabitatId, Level2HabitatId, Level3HabitatId, SiteHabitatPercentage }) => {
  const preBody = {
    Level1HabitatId,
    Level3HabitatId,
    Level2HabitatId,
    SiteHabitatPercentage
  }
  const body = filterNullAndUndefinedFieldsFromObject(preBody)
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/habitat` : `${path}/${siteId}`
  return postRequest(url, body)
}

export const requestGetSiteHabitats = (siteId, siteHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/habitat` : `${path}/${siteId}`
  return getRequest(url)
}

export const requestDeleteSiteHabitat = (siteHabitatId, siteHistoryId) => {
  const url = siteHistoryId ? `${reassessmentPath}/${siteHistoryId}/habitat/${siteHabitatId}` : `${path}/${siteHabitatId}`
  return deleteRequest(url)
}

export const requestUpdateSiteHabitat = (siteHabitatId, siteHistoryId, { Level1HabitatId, Level3HabitatId, Level2HabitatId, SiteHabitatPercentage }) => {

  const preBody = {
    Level1HabitatId,
    Level3HabitatId,
    Level2HabitatId,
    SiteHabitatPercentage
  }

  const body = filterNullAndUndefinedFieldsFromObject(preBody)

  if (siteHistoryId) {
    return patchRequest(`${reassessmentPath}/${siteHistoryId}/habitat/${siteHabitatId}`, body)
  }
  return putRequest(`${path}/${siteHabitatId}`, body)
}

const habitatsLevel1Path = '/api/site-habitat/habitats-level1';
export const requestGetHabitatsLevel1 = () => {
  const url = `${habitatsLevel1Path}`;
  return getRequest(url);
};

const habitatsLevel2Path = '/api/site-habitat/habitats-level2';
export const requestGetHabitatsLevel2 = () => {
  const url = `${habitatsLevel2Path}`;
  return getRequest(url);
};

const habitatsLevel3Path = '/api/site-habitat/habitats-level3';
export const requestGetHabitatsLevel3 = () => {
  const url = `${habitatsLevel3Path}`;
  return getRequest(url);
};


